import { useState } from "react";
import classNames from "classnames";
import ArrUpIcon from "../ui/ArrUpIcon";
import CloseIcon from "../ui/CloseIcon";
import DropdownIcon from "../ui/DropdownIcon";
import FormCardDetails from "./FormCardDetails";

// карточка на финальном шаге, бронирование
function BookingFormCardTwo({
  booking,
  hoteldata,
  step = 1,
  prevStep,
  nextStep,
  onClose,
  scrolled = 0,
  acceptRules = null,
}) {
  const [showPrices, setShowPrices] = useState(false);

  return (
    <div className="bookingCard bookingCard__mob bookingCard__dates1 tar mob_show">
      <div className="dfsp mb12">
        <div className="dfsp w100p mr24">
          <div>Бронирование на сумму</div>{" "}
          <div
            className={classNames("fg1 tac curp accordionBox", {
              opened: showPrices,
            })}
            onClick={() => setShowPrices((prev) => !prev)}
          >
            {booking.prices.total} ₽ &nbsp;
            <DropdownIcon w={14} h={8} fill="#585858ff" />
          </div>
        </div>
        <div>
          <span className="bookingClose curp" onClick={onClose}>
            <CloseIcon />
          </span>
        </div>
      </div>
      {showPrices && <FormCardDetails booking={booking} scrolled={scrolled} />}
      <div className="navs dfsp dfa mt6">
        <div className="changeTariff" onClick={prevStep}>
          <ArrUpIcon w={20} h={10} fill="#36549C" />
          &nbsp;назад
        </div>
        <div style={{ flexGrow: 1 }}>
          <button
            className="bookingCard__nextBtn"
            onClick={nextStep}
            disabled={!acceptRules}
          >
            Забронировать
          </button>
        </div>
      </div>
      <div className="details dfsp">
        <div className="step ml6 mr6">
          шаг {step == "contacts" && hoteldata.steps_count}{" "}
          {step == "services" && "2"} {step == "1" && "1"} из{" "}
          {hoteldata.steps_count}
        </div>
      </div>
    </div>
  );
}

export default BookingFormCardTwo;
